import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Divider,
  Chip,
  Button,
  CircularProgress,
  Modal,
  Select,
  MenuItem,
  IconButton,
  Tooltip,
  CardActions,
  Stack,
  TextField,
  CardHeader,
  useMediaQuery,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { deleteReservation } from "../api/dashboard";
import { useAuth } from "../context/AuthContext";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import QRCode from "react-qr-code";
import { Snackbar, Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { manualPay } from "../api/dashboard.js";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import QrCodeIcon from "@mui/icons-material/QrCode2";
import PaidIcon from "@mui/icons-material/AttachMoney";
import { useTheme } from "@mui/material/styles";
import { editReserve } from "../api/dashboard.js";
const UbikaReservationDetail = ({
  data,
  onDeleted,
  refetchAlojamiento,
  group,
  activityLogs,
}) => {
  const [loading, setLoading] = useState(false); // ✅ debe ir aquí arriba
  const { user } = useAuth();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedReservationId, setSelectedReservationId] = useState(null);
  const [selectedEmpleado, setSelectedEmpleado] = useState("");
  const empleades = user?.employes || [];
  const rooms = user?.rooms || [];
  const paymentLink = `${user.linkUrl}/#/completepay?reservationId=${data.reservationId}`;
  const [qrOpen, setQrOpen] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackMsg, setSnackMsg] = useState("");
  const [snackOpen2, setSnackOpen2] = useState(false);
  const [monto, setMonto] = useState("");
  const [manualModalOpen, setManualModalOpen] = useState(false);
  const [empleadoPago, setEmpleadoPago] = useState("");
  const [metodoPago, setMetodoPago] = useState("");
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const [actionSelected, setActionSelected] = useState("");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [snackSeverity, setSnackSeverity] = useState("success");
  const [editForm, setEditForm] = useState({
    fullName: data.fullName || "",
    dni: data.dni || "",
    startDate: data.startDate?.slice(0, 10) || "",
    endDate: data.endDate?.slice(0, 10) || "",
    numberPhone: data.numberphone || "",
    amount: data.amount || "",
    seña: data.seña || "",
    paymentMethod: data.paymentMethod || "",
    propertyId: user.propertyId || "",
    empleado: data.empleado || "", // 👈 Agregado aquí
  });

  if (!data?.reservationId) {
    return (
      <Box
        sx={{
          mt: 4,
          textAlign: "center",
          bgcolor: "#fff",
          p: 4,
          borderRadius: 4,
          boxShadow: 3,
        }}
      >
        <Typography variant="h5" color="error" gutterBottom>
          ❌ Reserva no disponible
        </Typography>
        <Typography variant="body1">
          La reserva que intentas visualizar no existe o ha sido eliminada.
        </Typography>
      </Box>
    );
  }
  const handleSaveEdit = async () => {
    const body = {
      reservationId: data.reservationId,
      ...editForm,
    };
    setLoading(true); // 👈 inicia el loading

    try {
      const res = await editReserve(body);

      if (res.data?.success) {
        setSnackMsg("✅ Reserva actualizada correctamente");
        setSnackSeverity("success");
        refetchAlojamiento();
        setEditModalOpen(false);
      } else {
        console.error("❌ Error al     reserva:", res.data?.message);
        setSnackMsg("❌ Error al actualizar reserva");
        setSnackSeverity("warning");
      }
    } catch (err) {
      console.error("❌ Error de conexión con el servidor:", err);

      if (
        err.response?.status === 400 &&
        err.response.data?.message?.includes("ocupada")
      ) {
        setSnackMsg(
          "🚫 ¡NO SE PUEDE CAMBIAR LA FECHA!\nLa unidad está OCUPADA en esas fechas.\n⚠️ No continuar ni forzar el cambio, puede causar sobreventa (OVERBOOKING)."
        );
        setSnackSeverity("error");
      } else {
        setSnackMsg("❌ Error al conectar con el servidor");
        setSnackSeverity("error");
      }
    }
    setLoading(false); // 👈 inicia el loading

    setSnackOpen(true);
  };

  const formatDate = (date) => {
    if (!date) return "Fecha inválida";

    const localDate = new Date(date);
    localDate.setMinutes(
      localDate.getMinutes() + localDate.getTimezoneOffset()
    ); // Corrige desfase UTC

    return localDate.toLocaleDateString("es-AR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };
  const mensajeCompleto = `💳 ¡Hola! Para confirmar tu reserva, podés abonar directamente desde este link de pago seguro:
👉 ${paymentLink}

Es el método más rápido y seguro: el sistema registra el pago automáticamente y no necesitas enviar comprobantes.
¡Gracias por tu preferencia! 🙌`;
  const handleEditReservation = async () => {
    const body = {
      reservationId: data.reservationId,
      amount: Number(monto),
      empleado: empleadoPago,
      metodo: metodoPago,
    };

    setLoading(true); // 👈 inicia el loading

    try {
      const res = await manualPay(body);

      if (res.data.success) {
        console.log("✅ Pago manual registrado correctamente:", res.data);
        setSnackMsg("Pago registrado correctamente");
        setSnackSeverity("success");
      } else {
        console.error("❌ Error al registrar pago:", res.data.message);

        if (res.status === 400 && res.data.message?.includes("ocupada")) {
          setSnackMsg(
            "❌ NO SE PUDO MODIFICAR LA RESERVA: La unidad está ocupada. ¡NO CONTINUAR!"
          );
          setSnackSeverity("error");
        } else {
          setSnackMsg("Error al registrar el pago");
          setSnackSeverity("warning");
        }
      }
    } catch (err) {
      console.error("❌ Error al registrar pago manual:", err);
      setSnackMsg("Error de conexión con el servidor");
      setSnackSeverity("error");
    } finally {
      setLoading(false); // 👈 termina el loading
      setSnackOpen2(true);
      setMonto("");
      setEmpleadoPago("");
      setMetodoPago("");
      refetchAlojamiento();
      setManualModalOpen(false);
    }
  };

  const handleRegistrarPago = async () => {
    const body = {
      reservationId: data.reservationId,
      amount: Number(monto),
      empleado: empleadoPago,
      metodo: metodoPago,
    };
    setLoading(true); // 👈 inicia el loading

    try {
      const res = await manualPay(body);

      if (res.data.success) {
        console.log("✅ Pago manual registrado correctamente:", res.data);
        setSnackMsg("Pago registrado correctamente");
      } else {
        console.error("❌ Error al registrar pago:", res.data.message);
        setSnackMsg("Error al registrar el pago");
      }
    } catch (err) {
      console.error("❌ Error al registrar pago manual:", err);
      setSnackMsg("Error de conexión con el servidor");
    }
    setLoading(false); // 👈 inicia el loading
    setSnackOpen2(true);
    setMonto("");
    setEmpleadoPago("");
    setMetodoPago("");
    refetchAlojamiento();
    setManualModalOpen(false);
  };

  const handleConfirmDelete = async () => {
    if (!selectedEmpleado) {
      alert("Debes seleccionar un empleado.");
      return;
    }

    try {
      setLoading(true);
      const response = await deleteReservation({
        idbeds: selectedReservationId,
        empleado: selectedEmpleado,
      });

      const result = response.data;

      if (result.success) {
        alert("✅ Reserva eliminada correctamente.");
        if (onDeleted) onDeleted(selectedReservationId);
        setModalOpen(false);
        setSelectedEmpleado("");
        setSelectedReservationId(null);
      } else {
        alert(`❌ Error: ${result.message}`);
      }
    } catch (error) {
      console.error("❌ Error al eliminar:", error);
      alert("Hubo un problema al intentar eliminar la reserva.");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = async (reservationId) => {
    const confirmDelete = window.confirm(
      "¿Estás seguro de que deseas eliminar esta reserva?"
    );
    if (!confirmDelete) return;

    if (empleades.length === 0) {
      alert("❌ No hay empleados registrados.");
      return;
    }

    const empleadoSeleccionado = prompt(
      `Indica el nombre del empleado que autoriza esta acción:\n\n${empleades.join(
        "\n"
      )}`
    );

    if (!empleadoSeleccionado || !empleades.includes(empleadoSeleccionado)) {
      alert("❌ Empleado no válido o cancelado.");
      return;
    }

    try {
      setLoading(true);
      const response = await deleteReservation({
        reservationId,
        empleado: empleadoSeleccionado,
      });

      const result = response.data;

      if (result.success) {
        alert("✅ Reserva eliminada correctamente.");
        if (onDeleted) onDeleted(reservationId);
      } else {
        alert(`❌ Error: ${result.message}`);
      }
    } catch (error) {
      console.error("❌ Error al eliminar:", error);
      console.log(error.response);
      if (error.response?.status === 403) {
        alert(
          "⚠️ No se puede eliminar esta reserva.\n\n" +
            "La reserva ya ha finalizado o su fecha de salida ya pasó.\n" +
            "Por precaución del sistema, las reservas pasadas no se pueden cancelar para evitar fraudes o errores administrativos."
        );
      } else {
        alert("❌ Hubo un problema al intentar eliminar la reserva.");
      }
    } finally {
      setLoading(false);
    }
  };

  const getRoomNames = () => {
    if (!Array.isArray(group) || group.length === 0)
      return ["Sin habitaciones asignadas"];

    const uniqueNames = new Set();

    group.forEach((res) => {
      const match = rooms.find(
        (r) =>
          String(r.roomId) === String(res.roomId) &&
          String(r.unitId) === String(res.unitId)
      );

      if (match) {
        // Privada: agregar siempre | Compartida: solo agregar si unitId === 0 (una vez)
        uniqueNames.add(`${match.name.toUpperCase()} `);
      } else {
        // Si no está en user.rooms, buscar por roomId (para compartidas adicionales)
        const sharedBase = rooms.find(
          (r) => String(r.roomId) === String(res.roomId) && r.type === "shared"
        );
        if (sharedBase) {
          uniqueNames.add(` ${sharedBase.name.toUpperCase()} `);
        }
      }
    });

    return Array.from(uniqueNames);
  };

  const calculateNights = (start, end) => {
    try {
      const startDate = new Date(start);
      const endDate = new Date(end);
      const diffTime = endDate - startDate;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays || 1;
    } catch {
      return 1;
    }
  };
  const handleCopy = (text, mensaje = "Copiado al portapapeles") => {
    navigator.clipboard.writeText(text);
    setSnackMsg(mensaje);
    setSnackOpen(true);
  };
  const handleAction = (action) => {
    switch (action) {
      case "qr":
        setQrOpen(true);
        break;
      case "edit":
        handleEditReservation();
        break;
      case "delete":
        handleDeleteClick(data.reservationId);
        break;
      case "manual":
        setManualModalOpen(true);
        break;
      default:
        break;
    }
    setActionSelected(""); // Reinicia el selector
  };
  const quickActions = isXs ? (
    <Select
      value={actionSelected}
      onChange={(e) => handleAction(e.target.value)}
      displayEmpty
      fullWidth
      size="small"
      sx={{ mt: 1 }}
    >
      <MenuItem disabled value="">
        Acciones rápidas
      </MenuItem>
      <MenuItem value="qr">🔗 Link de Pago</MenuItem>
      <MenuItem value="edit" onClick={() => setEditModalOpen(true)}>
        ✏️ Editar
      </MenuItem>
      <MenuItem value="delete" disabled={loading}>
        🗑 {loading ? "Eliminando..." : "Eliminar"}
      </MenuItem>
      <MenuItem value="manual">💵 Pago Manual</MenuItem>
    </Select>
  ) : (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        overflowX: "auto",
        pb: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <Tooltip title="Generar link de pago">
        <Button
          variant="contained"
          color="primary"
          startIcon={<QrCodeIcon />}
          onClick={() => setQrOpen(true)}
        >
          Link de Pago
        </Button>
      </Tooltip>

      <Tooltip title="Modificar reserva">
        <Button
          variant="outlined"
          color="secondary"
          startIcon={<EditIcon />}
          onClick={() => setEditModalOpen(true)}
        >
          Editar
        </Button>
      </Tooltip>

      <Tooltip title="Eliminar reserva">
        <Button
          variant="outlined"
          color="error"
          startIcon={<DeleteIcon />}
          onClick={() => handleDeleteClick(data.reservationId)}
          disabled={loading}
        >
          {loading ? "Eliminando..." : "Eliminar"}
        </Button>
      </Tooltip>

      <Tooltip title="Registrar pago manual">
        <Button
          variant="outlined"
          color="secondary"
          startIcon={<PaidIcon />}
          onClick={() => setManualModalOpen(true)}
        >
          Pago Manual
        </Button>
      </Tooltip>
    </Stack>
  );

  /** ---------- Filas de información ---------- */
  const rows = [
    ["👤 Huésped", data.fullName],
    ["🪪 DNI", data.dni],
    [
      "📅 Ingreso",
      `${formatDate(data.startDate)} – ${data.horaing || "15:00"}`,
    ],
    ["📆 Salida", formatDate(data.endDate)],
    ["📞 Teléfono", data.numberphone],
    ["📧 Email", data.email],
    ["🛏 Habitación", getRoomNames().join(", ")],
    ["👥 Huéspedes", data.guests],
    ["🌙 Noches", calculateNights(data.startDate, data.endDate)],
    [
      "📍 Estado interno",
      <Chip label={data.estadoIn} color="secondary" size="small" />,
    ],
    ["💵 Monto", `$${data.amount.toLocaleString()}`],
    ["💰 Seña", `$${data.seña.toLocaleString()}`],
    ["🧾 Tax OTA", `$${data.commissionAPI.toLocaleString()}`],
    [
      "🧮 Tax Ubika",
      `$${(data.amount * 0.03).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`,
    ],
    ["💳 Método pago", data.paymentMethod],
    ["👤 Origen", data.origin],
    ["🗂 ID Reserva", data.reservationId],
    ["📥 Creación", formatDate(data.createdAt)],
  ];

  return (
    <Box
      sx={{
        bgcolor: "#ECECEC",
        p: 4,
        boxShadow: 4,
        fontFamily: "'Red Hat Display', sans-serif",
      }}
    >
      <Snackbar
        open={snackOpen2}
        autoHideDuration={4000}
        onClose={() => setSnackOpen2(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity={snackSeverity} sx={{ width: "100%" }}>
          {snackMsg}
        </Alert>
      </Snackbar>
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            width: 300,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Confirmar eliminación
          </Typography>
          <Typography variant="body2" gutterBottom>
            Selecciona el empleado que autoriza la acción:
          </Typography>
          <Select
            fullWidth
            size="small"
            value={selectedEmpleado}
            onChange={(e) => setSelectedEmpleado(e.target.value)}
            sx={{ mb: 3 }}
          >
            {user?.employes?.map((emp, idx) => (
              <MenuItem key={idx} value={emp}>
                {emp}
              </MenuItem>
            ))}
          </Select>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              variant="outlined"
              fullWidth
              onClick={() => setModalOpen(false)}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              fullWidth
              color="error"
              onClick={handleConfirmDelete}
              disabled={!selectedEmpleado}
            >
              Eliminar
            </Button>
          </Box>
        </Box>
      </Modal>
      <Typography variant="h4" fontWeight="bold" color="#903AF2" gutterBottom>
        Detalle de la Reserva
      </Typography>
      <Card sx={{ mb: 4, borderRadius: 4, boxShadow: 3 }}>
        {/* Barra superior */}
        <CardHeader
          titleTypographyProps={{ fontWeight: "bold" }}
          title="Acciones rápidas"
          sx={{ bgcolor: "#f5f5f5", borderBottom: "1px solid #ddd", py: 2 }}
        />
        <Box overflow="auto" px={2}>
          {quickActions}
        </Box>

        <Divider />

        {/* Detalle de reserva */}
        <CardContent sx={{ px: 3, py: 2 }}>
          <TableContainer>
            <Table size="small">
              <TableBody>
                {rows.map(([label, value]) => (
                  <TableRow key={label}>
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{ fontWeight: 600, width: "45%" }}
                    >
                      {label}
                    </TableCell>
                    <TableCell align="right">{value}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
      {activityLogs && activityLogs.length > 0 && (
        <Card sx={{ mt: 4, borderRadius: 4, boxShadow: 3 }}>
          <CardHeader
            title="🕓 Historial de Actividades"
            titleTypographyProps={{ fontWeight: "bold" }}
            sx={{ bgcolor: "#f5f5f5", borderBottom: "1px solid #ddd", py: 2 }}
          />
          <CardContent sx={{ px: 3 }}>
            <TableContainer component={Box}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Fecha</TableCell>
                    <TableCell>Acción</TableCell>
                    <TableCell>Monto</TableCell>
                    <TableCell>Empleado</TableCell>
                    <TableCell>Descripción</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {activityLogs
                    .filter((log) => log.reservationId === data.reservationId)
                    .sort(
                      (a, b) =>
                        new Date(b.createdAt).getTime() -
                        new Date(a.createdAt).getTime()
                    )
                    .map((log, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          {log.createdAt
                            ? new Date(log.createdAt).toLocaleString("es-AR")
                            : "N/A"}
                        </TableCell>
                        <TableCell>{log.action}</TableCell>
                        <TableCell>
                          $
                          {log.amount?.toLocaleString("es-AR", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                          })}
                        </TableCell>

                        <TableCell>{log.performedBy}</TableCell>
                        <TableCell>{log.description}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}
      <Modal open={qrOpen} onClose={() => setQrOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#fefefe",
            p: 4,
            borderRadius: 3,
            boxShadow: 24,
            width: 380,
            maxWidth: "90vw",
            textAlign: "center",
          }}
        >
          {/* Botón de cerrar */}
          <IconButton
            onClick={() => setQrOpen(false)}
            sx={{ position: "absolute", top: 8, right: 8, color: "gray" }}
          >
            <CloseIcon />
          </IconButton>

          <Typography
            variant="h5"
            fontWeight="bold"
            gutterBottom
            color="primary"
          >
            Link de Pago Automático
          </Typography>

          <QRCode value={paymentLink} size={200} style={{ margin: "auto" }} />

          <Typography
            variant="body2"
            sx={{
              mt: 2,
              wordBreak: "break-word",
              fontSize: "0.9rem",
              color: "text.secondary",
            }}
          >
            {paymentLink}
          </Typography>

          <Stack spacing={1} mt={3}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              startIcon={<ContentCopyIcon />}
              onClick={() =>
                handleCopy(paymentLink, "Link copiado al portapapeles")
              }
            >
              Copiar solo el link
            </Button>

            <Button
              variant="outlined"
              color="secondary"
              fullWidth
              startIcon={<ContentCopyIcon />}
              onClick={() =>
                handleCopy(mensajeCompleto, "Mensaje completo copiado")
              }
            >
              Copiar mensaje para el cliente
            </Button>
          </Stack>

          <Typography
            variant="caption"
            sx={{ mt: 1, display: "block", color: "gray" }}
          >
            Puedes enviarlo por WhatsApp, mail o mensaje directo.
          </Typography>
        </Box>
      </Modal>
      <Modal open={manualModalOpen} onClose={() => setManualModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#fffdfc",
            p: 4,
            borderRadius: 3,
            boxShadow: 24,
            width: 380,
            maxWidth: "90vw",
          }}
        >
          {/* Botón de cerrar */}
          <IconButton
            onClick={() => setManualModalOpen(false)}
            sx={{ position: "absolute", top: 8, right: 8, color: "gray" }}
          >
            <CloseIcon />
          </IconButton>

          <Typography
            variant="h6"
            fontWeight="bold"
            gutterBottom
            color="warning.main"
          >
            Pago Manual
          </Typography>

          {/* Empleado */}
          <Typography variant="subtitle2" gutterBottom>
            Responsable que registra el pago
          </Typography>
          <Select
            fullWidth
            size="small"
            value={empleadoPago}
            onChange={(e) => setEmpleadoPago(e.target.value)}
            sx={{ mb: 3 }}
          >
            {user?.employes?.map((emp, idx) => (
              <MenuItem key={idx} value={emp}>
                {emp}
              </MenuItem>
            ))}
          </Select>

          {/* Método de pago */}
          <Typography variant="subtitle2" gutterBottom>
            Método de pago
          </Typography>
          <Select
            fullWidth
            size="small"
            value={metodoPago}
            onChange={(e) => setMetodoPago(e.target.value)}
            sx={{ mb: 3 }}
          >
            <MenuItem value="Efectivo">Efectivo</MenuItem>
            <MenuItem value="Transferencia">Transferencia</MenuItem>
            <MenuItem value="Débito">Débito</MenuItem>
            <MenuItem value="Crédito">Crédito</MenuItem>
            <MenuItem value="Otro">Otro</MenuItem>
          </Select>
          <Typography
            variant="body2"
            color="error"
            fontWeight="bold"
            gutterBottom
          >
            ingresar el valor en numeros enteros sin puntos ni comas
          </Typography>
          <Tooltip
            title="Ingresar el valor en números enteros, sin puntos ni comas."
            arrow
            placement="top"
          >
            <TextField
              label="Monto pagado"
              type="number"
              fullWidth
              variant="outlined"
              value={monto}
              onChange={(e) => setMonto(e.target.value)}
              sx={{ mb: 3 }}
            />
          </Tooltip>
          <Button
            variant="contained"
            color="warning"
            fullWidth
            onClick={
              !monto || !empleadoPago || !metodoPago || loading
                ? undefined
                : handleRegistrarPago
            }
            disabled={false} // Para evitar conflictos de eventos
            startIcon={
              loading ? <CircularProgress size={20} color="inherit" /> : null
            }
          >
            {loading ? "Registrando..." : "Confirmar Pago Manual"}
          </Button>
        </Box>
      </Modal>
      <Modal open={editModalOpen} onClose={() => setEditModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#fff",
            p: 4,
            borderRadius: 3,
            boxShadow: 24,
            width: 400,
            height: "80vh",
            overflow: "auto",
            maxWidth: "90vw",
          }}
        >
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            ✏️ Editar Reserva
          </Typography>

          <Tooltip title="Modificá solo los campos necesarios para evitar errores. los precios van SIN punto ( . )">
            <Box mb={2}>
              {[
                { label: "Nombre completo", name: "fullName" },
                { label: "DNI", name: "dni" },
                { label: "Teléfono", name: "numberPhone" },
                { label: "Monto", name: "amount", type: "number" },
                { label: "Seña", name: "seña", type: "number" },
              ].map(({ label, name, type = "text" }) => (
                <TextField
                  key={name}
                  label={label}
                  name={name}
                  type={type}
                  fullWidth
                  variant="outlined"
                  value={editForm[name]}
                  onChange={(e) =>
                    setEditForm((prev) => ({ ...prev, [name]: e.target.value }))
                  }
                  sx={{ mb: 2 }}
                />
              ))}
            </Box>
          </Tooltip>

          <Tooltip title="⚠️ Si modificás las fechas, se verificará la disponibilidad. Podés provocar overbooking si no hay lugar.">
            <Box mb={2}>
              <TextField
                label="Ingreso"
                type="date"
                fullWidth
                value={editForm.startDate}
                onChange={(e) =>
                  setEditForm((prev) => ({
                    ...prev,
                    startDate: e.target.value,
                  }))
                }
                InputLabelProps={{ shrink: true }}
                sx={{ mb: 2 }}
              />
              <TextField
                label="Salida"
                type="date"
                fullWidth
                value={editForm.endDate}
                onChange={(e) =>
                  setEditForm((prev) => ({ ...prev, endDate: e.target.value }))
                }
                InputLabelProps={{ shrink: true }}
              />
            </Box>
          </Tooltip>

          <Tooltip title="Seleccioná un responsable antes de guardar.">
            <Box mb={3}>
              <Select
                fullWidth
                size="small"
                value={editForm.empleado}
                onChange={(e) =>
                  setEditForm((prev) => ({ ...prev, empleado: e.target.value }))
                }
              >
                {user?.employes?.map((emp, idx) => (
                  <MenuItem key={idx} value={emp}>
                    {emp}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Tooltip>

          <Stack direction="row" spacing={2}>
            <Button
              variant="outlined"
              color="secondary"
              fullWidth
              onClick={() => setEditModalOpen(false)}
              disabled={loading}
            >
              Cancelar
            </Button>
            <Tooltip title="Guardá solo si estás seguro de los cambios.">
              <span style={{ width: "100%" }}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleSaveEdit}
                  disabled={loading || !editForm.empleado}
                >
                  {loading ? "Guardando..." : "Guardar cambios"}
                </Button>
              </span>
            </Tooltip>
          </Stack>
        </Box>
      </Modal>
      <Snackbar
        open={snackOpen2}
        autoHideDuration={3000}
        onClose={() => setSnackOpen2(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="success" sx={{ width: "100%" }}>
          Pago registrado correctamente
        </Alert>
      </Snackbar>
      <Snackbar
        open={snackOpen}
        autoHideDuration={5000}
        onClose={() => setSnackOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={snackSeverity}
          sx={{ whiteSpace: "pre-line", width: "100vh" }}
        >
          {snackMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default UbikaReservationDetail;
